<app-navbar></app-navbar>
<main>
  <app-hero></app-hero>
  <app-words-strip></app-words-strip>
  <app-about></app-about>
  <app-services></app-services>
  <app-talleres></app-talleres>
  <app-colaboraciones></app-colaboraciones>
  <app-testimonials></app-testimonials>
  <app-faqs></app-faqs>
  <app-cta></app-cta>
  <app-images-strip></app-images-strip>
  <app-contact></app-contact>
</main>
<app-footer></app-footer>
